export enum ThemeColors {
  shark = 'var(--color-shark)',
  charade = 'var(--color-charade)',
  brightGray = 'var(--color-bright-gray)',
  cadetBlue = 'var(--color-cadet-blue)',
  shuttleGray = 'var(--color-shuttle-gray)',
  white = 'var(--color-white)',
  geraldine = 'var(--color-geraldine)',
}
